export const FETCH_INTERNSHIPLIST_REQUEST = 'FETCH_INTERNSHIPLIST_REQUEST'
export const FETCH_INTERNSHIPLIST_SUCCES = 'FETCH_INTERNSHIPLIST_SUCCES'
export const FETCH_INTERNSHIPLIST_ERROR = 'FETCH_INTERNSHIPLIST_ERROR'



// WEBPACK FOOTER //
// ./src/constants/InternshipList.js